<img src="/assets/images/login/dialog/close.svg" alt="Cerrar" class="close-icon" (click)="close()">
<div class="title" [innerHTML]="'forgotPasswordDialog_Data1' | i18n"></div>
<form #emailForm="ngForm">
  <input type="text" placeholder="{{ 'forgotPasswordDialog_Data2' | i18n: translationModes.PLACEHOLDER }}" [(ngModel)]="email"
  name="email" #emailInput="ngModel" required [pattern]="emailPattern">
  <div *ngIf="isError" class="error-message" [innerHTML]="'forgotPasswordDialog_Data4' | i18n"></div>
  <div class="send-btn" [ngClass]="{'send-error': isError}" [innerHTML]="'forgotPasswordDialog_Data3' | i18n" (click)="send()" [ngClass]="{'disabled': !emailForm.valid}"></div>
</form>
